import { render } from "./Header.vue?vue&type=template&id=5e21b200&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5e21b200&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e21b200"

export default script